<template>
  <div class="pa-0" style="display: contents;">
    <div class="loading" v-show="!active">
      <k-progress-circular class="loading-icon" indeterminate v-bind:size="50"></k-progress-circular>
    </div>

    <k-layout v-if="active">
      <k-flex c5>
        <tag-editor :event_uuid="id" :uuid="tag_uuid" v-if="id"></tag-editor>
      </k-flex>
      <k-flex c7>
        <tag-list :event_uuid="id" v-if="id"></tag-list>
      </k-flex>
    </k-layout>
  </div>
</template>

<script>
import Vue from 'vue'


import TagEditor from '@/components/events/tags/Editor.vue'
import TagList from '@/components/events/tags/List.vue'
import TagModel from '@/models/tag.js'

export default {
	props: ["id"],
  components: {
    TagEditor,
    TagList
  },
  data () {
    var tags_ch = this.$cloudserver.channel("events:tags:"+this.id);

    return {
      ws_channel: tags_ch,
      active: this.$route.query.tab == "tags",
      tags: {},
      filtered_tags: [],
      headers: [
        {text: "Stream time", sortable: false, width: 20},
        {text: "Title", sortable: false},
        {text: "Time", sortable: false},
        {text: "Actions", sortable: false, align: "right", width: 300}
      ],
      tag_uuid: undefined
    }
  },
  created() {
    this.ws_channel.join();
  },
  methods: {
    get_title(tag) {
      return TagModel.title(tag);
    },
    get_stream_time (tag) {
      return TagModel.formatted_stream_time(tag);
    },
    get_time(tag) {
      return TagModel.formatted_date(tag) + " " + TagModel.formatted_time(tag);
    }
  },
  watch: {
    "ws_channel.data": {
      handler(newVal, oldVal) {
        var self = this;
        console.log(newVal);
        if (typeof(newVal.tags) != "undefined") {
          _.each(newVal.tags, (tag) => {
            Vue.set(self.tags, tag.uuid, tag);
          });
        }
        if (typeof(newVal.tag) != "undefined") {
          var tag = newVal.tag;
          Vue.set(self.tags, tag.uuid, tag);
        }
        self.filtered_tags = Object.values(self.tags);
      },
      deep: true
    },
    "$route.query.tab" (newVal) {
      if(newVal == "tags") {
        setTimeout(() => {
          this.active = true;
        },200);
      }
    }
  }
}
</script>
